export default __webpack_public_path__ + "static/media/bginscription.03c4abf5.png";